
export type ChatRoomResponseLastMessageBasicInfoAllOfTwoType = typeof ChatRoomResponseLastMessageBasicInfoAllOfTwoType[keyof typeof ChatRoomResponseLastMessageBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatRoomResponseLastMessageBasicInfoAllOfTwoType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
